import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Radio } from '@mantine/core';
import ResponsiveModal from './ResponsiveModal';
import AppStack from './AppStack';
import { singularPluralFormat } from '../../helpers/format';

const ResourceSelectModal = ({
  isOpen,
  onClose,
  selectedIds,
  totalItemCount,
  formSectionProps,
  filter,
  selectLabel,
  selectLabelDescription,
  onSelect,
  skipSelect,
  children,
  singular,
  plural,
  ...rest
}) => {
  const [formState, setFormState] = useState({
    hasSelected: false,
    selectAll: false
  });
  const hasFilter = filter && Object.keys(filter).some((key) => filter[key]);

  const singularTitle = singular || 'product';
  const pluralTitle = plural || 'products';

  useEffect(() => {
    if (isOpen) {
      const allSelected = selectedIds && totalItemCount === selectedIds.length;

      setFormState({
        hasSelected: allSelected || skipSelect || false,
        selectAll: false
      });
    }
  }, [isOpen]);

  return (
    <ResponsiveModal
      formSectionProps={
        children && formState.hasSelected
          ? formSectionProps
          : {
              onCancel: onClose,
              onSubmit: () => {
                setFormState({ ...formState, hasSelected: true });
                onSelect(formState.selectAll ? 'all' : 'selected');
              },
              submitTitle: 'Continue',
              submitColor: 'dark'
            }
      }
      isOpen={isOpen}
      onClose={onClose}
      {...rest}
    >
      {children && formState.hasSelected ? (
        children
      ) : (
        <AppStack>
          <Radio.Group
            description={selectLabelDescription}
            label={selectLabel}
            onChange={(v) => {
              setFormState({
                ...formState,
                selectAll: v === 'all'
              });
            }}
            value={formState.selectAll ? 'all' : 'selected'}
          >
            <AppStack style={{ gap: 10, marginTop: 10 }}>
              <Radio
                label={
                  hasFilter
                    ? `All ${pluralTitle} by filter`
                    : `All ${pluralTitle}`
                }
                value="all"
              />
              <Radio
                label={`Selected ${singularPluralFormat(
                  selectedIds?.length ?? 0,
                  singularTitle,
                  pluralTitle
                )}`}
                value="selected"
              />
            </AppStack>
          </Radio.Group>
        </AppStack>
      )}
    </ResponsiveModal>
  );
};

ResourceSelectModal.propTypes = {
  children: PropTypes.node,
  filter: PropTypes.object,
  formSectionProps: PropTypes.object,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSelect: PropTypes.func,
  onSuccess: PropTypes.func,
  plural: PropTypes.string,
  selectLabel: PropTypes.string,
  selectLabelDescription: PropTypes.string,
  selectedIds: PropTypes.array,
  singular: PropTypes.string,
  skipSelect: PropTypes.bool,
  totalItemCount: PropTypes.number
};

export default ResourceSelectModal;
